"use client";
import { useState } from "react";
import ModalVideo from "react-modal-video";
import "react-modal-video/css/modal-video.css";

const VIDEO_ID = "9eMypiao7hU";

export default function VideoOne() {
    const [isOpen, setIsOpen] = useState(false);

    return (
        <>
            {/* Video One Start */}
            <section className="video-one" style={{ position: "relative", zIndex: 10000 }}>
                <div className="container">
                    <div className="video-one__inner wow fadeInUp" data-wow-delay="300ms">
                        <div className="video-one__img" style={{ position: "relative" }}>

                            {/* Background Video */}
                            <video
                                className="video-one__bg"
                                autoPlay
                                muted
                                loop
                                playsInline
                            >
                                <source src="/video/mulema.mp4" type="video/mp4" />
                                Your browser does not support the video tag.
                            </video>

                            {/* Play Button */}
                            <div className="video-one__video-link">
                                <div
                                    onClick={() => setIsOpen(true)}
                                    className="video-popup"
                                    style={{ cursor: "pointer" }}
                                >
                                    <div className="video-one__video-icon">
                                        <span className="icon-awesome-play"></span>
                                        <i className="ripple"></i>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>

                {/* Modal */}
                <ModalVideo
                    channel="youtube"
                    isOpen={isOpen}
                    videoId={VIDEO_ID}
                    onClose={() => setIsOpen(false)}
                />
            </section>
            {/* Video One End */}
        </>
    );
}
